<template>
    <div class="m-combat-rank">
        <div class="m-wrap ta-center i-zb-w">
            <h3 class="tb-title ">股神争霸</h3>
            <p class="t-box ta-center">
                天地英雄争霸榜
                <!--更新时间：{{updateTime}}-->
            </p>
            <div class="ta-center tabs-hd">
                <a href="javascript:;" :class="tabsType===4 ?'active':''" @click="tabsHead(4)" data-rank-type="4">日榜</a>
                <a href="javascript:;" :class="tabsType===3 ?'active':''" @click="tabsHead(3)" data-rank-type="3">周榜</a>
                <a href="javascript:;" :class="tabsType===0 ?'active':''" @click="tabsHead(0)" data-rank-type="0">周连中榜</a>
            </div>
            
            <div class="index-ranking-wrap">
                <div class="table-body table-body__bg pd-h-sm table-body--bd" :style="{maxHeight:boxHeight?'initial':'6rem'}">
                    <div class="updown-combat-ranking" id="js-combat-4" v-show="tabsType===4">
                        <div class="small pd-v-sm">日榜是交易日的排名榜单！</div>
                        <div class="">
                            <rank-table :list="list4" :type="tabsType"></rank-table>
                        </div>
                    </div>
                    <div class="updown-combat-ranking" id="js-combat-3" v-show="tabsType===3">
                        <div class="small pd-v-sm">一周的金币赢利榜单！</div>
                        <div class="">
                            <rank-table :list="list3" :type="tabsType"></rank-table>
                        </div>
                    </div>
                    <div class="updown-combat-ranking" id="js-combat-0" v-show="tabsType===0">
                        <div class="small pd-v-sm">一周的连中榜单！</div>
                        <div class="">
                            <rank-table :list="listVictory" :type="tabsType"></rank-table>
                        </div>
                    </div>
                </div>
                <div>
                    <a href="javascript:;" class="btn-slide" type="default"  @click="boxHeight=!boxHeight"><van-icon v-if="boxHeight" name="arrow-up" /> <van-icon v-else name="arrow-down" /></a>
                </div>
            </div>            
            <div class="index-ranking-myrank" style="display:none" v-show="tabsType===4 && recordInfo.userDayIncomeRank>10 && recordInfo.uid === myUid">
                <div class="hr"></div>              
                <div class="table-body table-body__bg skin-shadow">
                    <table class="m-table ta-left">
                        <tr>
                            <td width="10%" class="ta-center cl-red">{{recordInfo.userDayIncomeRank}}</td>
                            <td class="">
                                <figure class="pd-2">
                                    <img :src="myLogo"  style="width: 0.6rem; height: 0.6rem;" class="u-logo">
                                    <span class="inlineBlock achMainLiNick">&nbsp;{{myNick}}</span>
                                </figure>
                            </td>
                            <td width="25%" class="ta-center cl-red ta-right"><k-num :value="recordInfo.dTotalIncome" /> <span class="icon-gold"></span></td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="index-ranking-myrank" style="display:none" v-show="tabsType===3 && recordInfo.userWeekIncomeRank>10 && recordInfo.uid === myUid">
                <div class="hr"></div>
                <div class="table-body table-body__bg skin-shadow">
                    <table class="m-table ta-left">
                        <tr>
                            <td width="12%" class="ta-center cl-red table-td-12">{{recordInfo.userWeekIncomeRank}}</td>
                            <td style="padding:10px;">
                                <k-user :logo="myLogo" :nick="myNick"></k-user>
                                <!-- <figure class="pd-2">
                                    <img :src="myLogo"  style="width: 0.6rem; height: 0.6rem;" class="u-logo">
                                    <span class="inlineBlock achMainLiNick">&nbsp;{{myNick}}</span>
                                </figure> -->
                            </td>
                            <td width="25%" class="ta-center cl-red ta-right"><k-num :value="recordInfo.wTotalIncome" /> <span class="icon-gold"></span></td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import {getServerTime, dataFormat } from '../../../utils/base'
    import RankTable from '../../components/rank-table'
    export default {
        data() {
            return {
                updateTime : dataFormat(getServerTime(), 'yyyy-MM-dd'),
                tabsType: 4,
                pageNum : 50,
                list4 : null,
                list3 : null,
                listVictory : null,
                boxHeight : false
            }
        },
        components :{
            'rank-table' : RankTable
        },
        computed: {
            ...mapGetters(['myUid','myLogo','myNick']),
            ...mapGetters('home', ['transDate']),
            ...mapGetters('ranking', ['moneyRankingList','weekRankingList']),
            ...mapGetters('mybet', ['recordInfo']),
        },
        methods: {           
            ...mapActions('ranking', ['loadMoneyRanking','loadWeekRankingList']),
            ...mapActions('mybet', ['loadMytRecordInfo']),
            rankClass(index){
                return index < 3 ? ('sort-' + index) : ''
            },
            tabsHead(type){                
                if(type === this.tabsType) return
                this.tabsType = type
                if(type < 1){
                    if(!this.listVictory){
                        this.weekApi()
                    }                    
                } else {
                    if(!this['list' + type]){
                        this.moneyApi()
                    }
                    
                }
            },
            async moneyApi(){
                const R = await this.loadMoneyRanking({
                    flag : this.tabsType,
                    pageNum : this.pageNum, source: 'index'
                })
                this['list' + this.tabsType] = R.list || []
            },
            async weekApi(){
                const R = await this.loadWeekRankingList({
                    pageNum : this.pageNum,
                    source: 'index'
                })
                this.listVictory = R.list || []
            },
        },
        async created() {
            this.moneyApi()
            //this.weekApi()
        },
        watch: {
            myUid(n){
                if(n){
                    this.loadMytRecordInfo()
                }
            }
        },
    }
</script>